import request from '@/shared/api/request';

export const saveBaremetalTags = (id: number, tags: string[]): Promise<{ tags: string[] }> =>
  request({
    url: `/baremetals/${id}/tags/`,
    method: 'PUT',
    data: { tags },
  });
